import { Badge, Card } from './ui';
import { Icon, type IconName } from './Icon';

/**
 * Placeholder for a planned module. Phase 1 ships navigation + architecture;
 * module logic arrives in a later phase. Deliberately shows NO fake data.
 */
export function ModulePlaceholder({
  icon,
  title,
  description,
  bullets,
  badge = 'Arriving in Phase 2',
}: {
  icon: IconName;
  title: string;
  description: string;
  bullets: string[];
  badge?: string;
}) {
  return (
    <div className="space-y-5">
      <header>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">{title}</h1>
        <p className="mt-1 text-sm text-slate-500">{description}</p>
      </header>

      <Card className="flex flex-col items-center p-10 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-indigo-100 text-indigo-600">
          <Icon name={icon} className="h-8 w-8" />
        </span>
        <Badge tone="indigo" className="mt-4">
          {badge}
        </Badge>
        <h2 className="mt-3 text-lg font-semibold text-slate-900">{title} is coming next</h2>
        <p className="mt-1 max-w-xl text-sm text-slate-500">
          The foundation (navigation, permissions, branch awareness) is live — this module builds on
          top of it.
        </p>
        <ul className="mt-5 grid w-full max-w-xl grid-cols-2 gap-2 text-left">
          {bullets.map((bullet) => (
            <li key={bullet} className="flex items-start gap-2 rounded-xl bg-slate-50 px-3 py-2.5 text-sm text-slate-600">
              <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
              {bullet}
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}